module.exports = __webpack_public_path__ + "static/media/caft-accredited.aa23ecf9.png";